import React, { PureComponent } from 'react';
import ModalWrapper, { withOnClose } from '../ModalWrapper';
import Translator from '../../../requests/apa/Translator';
import Asset from '../../../requests/apa/Asset';
import Device from '../../../devices/device';
import Utils, { setInitialFocus } from '../../../utils/Utils';
import store from '../../../store';
import { HIDE_MODAL } from '../../../actions/modal';
import { Button } from '../../../packages/components/lib/Button';
import './styles/_AAFModalPromocionActivaHBOMax.scss';
import { setModalDismissHBO } from '../../CardNew/utils';
import { sendMetricSelectContentHBO } from '../../../components/CardNew/utils.js';

class AAFModalPromocionActivaHBOMax extends PureComponent {
	// Descarta el fallback de Asset.get (la propia key) cuando no hay URL de imagen válida
	static isImageUrl(value) {
		if (!value || typeof value !== 'string') {
			return false;
		}
		return /^(https?:\/\/|\/\/|data:image\/)/i.test(value.trim())
			|| /\.(png|jpe?g|gif|webp|svg)$/i.test(value.trim());
	}

	constructor(props) {
		super(props);

		this.keys = Device.getDevice().getKeys();
		const hboMaxLogoAsset = Asset.get('activahbomax_modal2_postercontenido_hbomax');
		this.hboMaxLogo = AAFModalPromocionActivaHBOMax.isImageUrl(hboMaxLogoAsset)
			? hboMaxLogoAsset
			: '';

		this.texto1Parrafo1 = Utils.cutPlayerString(
			Translator.get('activahbomax_modal2_texto_parrafo1'),
			158
		);
		this.texto1Parrafo2 = Utils.cutPlayerString(
			Translator.get('activahbomax_modal2_texto_parrafo2'),
			158
		);
		this.texto1Parrafo3 = Utils.cutPlayerString(
			Translator.get('activahbomax_modal2_texto_parrafo3'),
			158
		);

		this.texto2Parrafo1 = Utils.cutPlayerString(
			Translator.get('activahbomax_modal2_texto_parrafo4'),
			86
		);
		this.texto2Parrafo2 = Utils.cutPlayerString(
			Translator.get('activahbomax_modal2_texto_parrafo5'),
			86
		);
		this.texto2Parrafo3 = Utils.cutPlayerString(
			Translator.get('activahbomax_modal2_texto_parrafo6'),
			86
		);

		this.acceptButtonText = Utils.cutPlayerString(
			Translator.get('activahbomax_modal2_boton_texto_aceptar'),
			31
		);
		this.laterButtonText = Utils.cutPlayerString(
			Translator.get('activahbomax_modal2_boton_texto_nomostrar'),
			31
		);

		this.titleMetrics = this.texto1Parrafo1 + ' ' + this.texto1Parrafo2 + ' ' + this.texto1Parrafo3;
		this.handleAccept = this.handleAccept.bind(this);
		this.handleDontShowAgain = this.handleDontShowAgain.bind(this);
	}

	componentDidMount() {
		setTimeout(() => {
			const primaryButton = document.querySelector('#hbomax-promo-accept-button');
			if (primaryButton && primaryButton.id) {
				setInitialFocus(`#${primaryButton.id}`, false);
			}
		}, 300);
	}

	handleAccept(e) {
		e.preventDefault();
		e.stopPropagation();

		sendMetricSelectContentHBO(this.props.data, this.titleMetrics, this.acceptButtonText);
		this.closeModal();
	}

	async handleDontShowAgain(e) {
		setModalDismissHBO();
		e.preventDefault();
		e.stopPropagation();

		sendMetricSelectContentHBO(this.props.data, this.titleMetrics, this.laterButtonText);
		this.closeModal();
	}

	closeModal() {
		const dispatcher = (this.props && this.props.dispatch) || (store && store.dispatch);
		if (dispatcher && typeof dispatcher === 'function') {
			dispatcher({ type: HIDE_MODAL });
		}
	}

	render() {
		return (
			<ModalWrapper classNameComponent="aaf-modal-promocion-activa-hbomax-overlay">
				<div
					className={`hbomax-promo-modal-content${
						this.hboMaxLogo ? '' : ' hbomax-promo-modal-content--no-logo'
					}`}
				>

					<div className="hbomax-promo-text-uno-container">
						<span className="hbomax-promo-title">{this.texto1Parrafo1}</span>{' '}
						<span className="hbomax-promo-title">{this.texto1Parrafo2}</span>{' '}
						<span className="hbomax-promo-title">{this.texto1Parrafo3}</span>
					</div>

                    <div
						className="hbomax-promo-image-container"
						style={!this.hboMaxLogo ? { display: 'none' } : undefined}
					>
						{this.hboMaxLogo && (
							<img 
								src={this.hboMaxLogo} 
								className="hbomax-promo-image"
							/>
						)}
					</div>

                    <div className="hbomax-promo-text-dos-container">
						<span className="hbomax-promo-title">{this.texto2Parrafo1}</span>{' '}
						<span className="hbomax-promo-title">{this.texto2Parrafo2}</span>{' '}
						<span className="hbomax-promo-title">{this.texto2Parrafo3}</span>
					</div>

					<div className="hbomax-promo-buttons-container">
						<Button
							id="hbomax-promo-accept-button"
							type="button"
							variant={null}
							className="hbomax-promo-button hbomax-promo-button-primary focusable"
							onClick={this.handleAccept}
						>
							{this.acceptButtonText}
						</Button>

						<Button
							type="button"
							variant={null}
							className="hbomax-promo-button hbomax-promo-button-secondary focusable"
							onClick={this.handleDontShowAgain}
						>
							{this.laterButtonText}
						</Button>
					</div>
					</div>

			</ModalWrapper>
		);
	}
}

export default withOnClose(AAFModalPromocionActivaHBOMax);



// WEBPACK FOOTER //
// ./src/components/Modal/ActivaHBOMaxQR/AAFModalPromocionActivaHBOMax.jsx